// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__12CLI","dragIcon":"Choice_dragIcon__sk9JW","left":"Choice_left__tV16k","input":"Choice_input__1iCcX"};